const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');
// @actions
const accountChequesActions = require('actions/accountCheques');
const accountCancelChequebookActions = require('actions/accountCancelChequebook');
// @components
import OKLayout from 'components/commons/OKLayout/OKLayout';
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { AccountCancelChequebookStep1 } = require('components/accounts/accountCancelChequebookSteps/accountCancelChequebookStep1/accountCancelChequebookStep1');
const AccountCancelChequebookStep2 = require('components/accounts/accountCancelChequebookSteps/accountCancelChequebookStep2/accountCancelChequebookStep2');
const AccountCancelChequebookSuccessStep = require('components/accounts/accountCancelChequebookSteps/accountCancelChequebookSuccessStep/accountCancelChequebookSuccessStep');
const AccountDetailsSideBar = require('components/accounts/accountDetailsSidebar/accountDetailsSidebar');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
// @utilities
const AccessHelper = require('utilities/accessHelper');
// @constants
const { accountConstants } = require('utilities/accessHelperConditions/accounts');
const { GRAPHIC_TUTOR_TYPE_4 } = require('constants/index');
import { NEGATIVE } from 'constants/layout';

class AccountCancelChequebookView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.onCancel = this.onCancel.bind(this);
    }

    componentDidMount() {
        const { history, immAccounts, immAccountsCheques, match: { params: { accountId, chequebookIndex } } } = this.props;

        AccessHelper.allowAccess(accountConstants.ACCOUNTS_CANCEL_CHEQUEBOOK, { immAccounts, accountId, immAccountsCheques, chequebookIndex }, history);
    }

    componentWillUpdate() {
        const { match: { params: { accountId } }, immAccountsCheques } = this.props;

        if (immAccountsCheques.size === 0 && accountId) {
            this.props.requestCheques(accountId);
        }
    }

    componentWillUnmount() {
        this.props.reset();
    }

    onCancel() {
        const { accountId } = this.props.match.params;
        this.props.history.push(`/myprofile/accounts/${accountId}/cheques`);
    }

    buildSuccessful(accountId) {
        const { match: { params: { chequebookIndex } }, immAccountsCheques, requestCheques } = this.props;

        return (
            <section className="row no-outside-gutter">
                <div className="col-xs-offset-2 col-xs-8 one-column">
                    <AccountCancelChequebookSuccessStep
                        immAccountsCheques={immAccountsCheques}
                        requestCheques={requestCheques}
                        accountId={accountId}
                        chequebookIndex={chequebookIndex}
                        handleGoBack={this.onCancel}
                    />
                </div>
            </section>
        )
    }

    buildWizard(accountId) {
        const {
            match: { params: { chequebookIndex } },
            immAccountCancelChequebook,
            validateStep,
            setVisibleStep,
            setWillCancel,
            postChange,
            immAccountsCheques,
            requestCheques,
            immAccounts
        } = this.props;
        const immSteps = immAccountCancelChequebook.get('steps');
        const visibleStep = immAccountCancelChequebook.get('visibleStep');
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: () => postChange(accountId, chequebookIndex),
            cancel: this.onCancel
        };

        return (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={visibleStep}
                isFetching={false}
                showPreLeaveModal={true}
            >
                <WizardStep position="first" cancelButton={true}>
                    <AccountCancelChequebookStep1
                        immAccountCancelChequebook={immAccountCancelChequebook}
                        immAccountsCheques={immAccountsCheques}
                        requestCheques={requestCheques}
                        accountId={accountId}
                        chequebookIndex={chequebookIndex}
                    />
                </WizardStep>
                <WizardStep
                    addLoadingBehaviour={true}
                    position="last"
                    immFinalButton="accountCancelChequebook-finalButtonLabel"
                    cancelButton={true}
                >
                    <AccountCancelChequebookStep2
                        immAccounts={immAccounts}
                        accountId={accountId}
                    />
                </WizardStep>
            </Wizard>
        )
    }

    render() {
        const { match: { params: { accountId } }, immAccounts, immAccountCancelChequebook } = this.props;
        const immAccount = immAccounts.get('byId').get(accountId);
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-accounts'),
                url: '/myprofile/cards'
            },
            {
                text: immAccount.get('alias'),
                url: `/myprofile/accounts/${accountId}/movements`
            },
            {
                text: formatText('breadcrumb-chequebook'),
                url: `/myprofile/accounts/${accountId}/cheques`
            },
            {
                text: formatText('breadcrumb-cancelChequebook')
            }
        ];
        const subtitleLeft = immAccount.get('catalogData').get('subtype');
        const subtitleRight = getLastNChars(immAccount.get('iban'));
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_4}
                title={formatText('tutorials-bookReceiptTitle')}
            />
        );

        let bodyContent;
        if (immAccountCancelChequebook.get('submitSuccessful')) {
            bodyContent = this.buildSuccessful(accountId);
        } else {
            bodyContent = (
                <section className="row no-outside-gutter">
                    <div className="col-xs-8">
                        {this.buildWizard(accountId)}
                    </div>
                    <div className="col-xs-4">
                        <AccountDetailsSideBar immAccount={immAccount} />
                    </div>
                </section>
            );
        }

        return (
            <OKLayout
                breadcrumb={mappingBreadcrumb}
                contentPosition={NEGATIVE}
                title={getFinalTitle('accountCancelChequebook-cancelChequebook')}
                loading={!immAccount}
                section="accounts"
                subtitleLeft={subtitleLeft}
                subtitleRight={subtitleRight}
                tutorial={tutorial}
            >
                {bodyContent}
            </OKLayout>
        );
    }
}

AccountCancelChequebookView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immAccountsCheques: PropTypes.object.isRequired,
    immAccountCancelChequebook: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    requestCheques: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    postChange: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired
};

module.exports.constructor = AccountCancelChequebookView;
module.exports.AccountCancelChequebookView = connect(
    state => ({
        immAccounts: state.accounts,
        immAccountsCheques: state.accountsCheques,
        immAccountCancelChequebook: state.accountCancelChequebook
    }),
    {
        requestCheques: accountChequesActions.requestCheques,
        validateStep: accountCancelChequebookActions.validateStep,
        setWillCancel: accountCancelChequebookActions.setWillCancel,
        setVisibleStep: accountCancelChequebookActions.setVisibleStep,
        postChange: accountCancelChequebookActions.postChange,
        reset: accountCancelChequebookActions.reset
    }
)(withRouter(AccountCancelChequebookView));
